import { Navigate, useLocation } from 'react-router-dom';
import { LandingPage, LANDING_PAGES } from './landing-page';
import { LandingV2Page, V2_PAGES } from '../landing-v2/landing-v2-page';

/** One lazy route for every landing page: pages with v2 copy use the v2 template, the rest keep v1. */
export function LandingRoute() {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/$/, '');
  const v2 = V2_PAGES.find((p) => p.url === path);
  if (v2) return <LandingV2Page page={v2} />;
  const page = LANDING_PAGES.find((p) => p.url === path);
  if (!page) return <Navigate to="/" replace />;
  return <LandingPage page={page} />;
}
